<div>
  <div class="col-md-12">
    @if (
      comment[$comment.type] === commentType.manualAuditIssueComment ||
      comment[$comment.type] === commentType.addFlag ||
      comment[$comment.type] === commentType.removeFlag
    ) {
      <div
        id="{{ 'accordion-header-' + randomString }}"
        class="d-flex"
        [ngClass]="{ internal: comment[$manualAuditIssueComment.internal] }"
      >
        <label for="{{ 'expandComment-' + randomString }}" class="visuallyhidden">{{ 'added_comment' | translate }}</label>
        <button
          id="{{ 'expandComment-' + randomString }}"
          type="button"
          class="btn btn-link d-flex mt-1 mb-1"
          value="true"
          [attr.aria-expanded]="viewComment.value"
          #viewComment
          (click)="viewComment.value = viewComment.value === 'true' ? 'false' : 'true'"
        >
          @switch (viewComment.value) {
            @case ('true') {
              <svg class="align-items-start"><use xlink:href="#chevron-bottom"></use></svg>
            }
            @default {
              <svg class="align-items-start"><use xlink:href="#chevron-right"></use></svg>
            }
          }
        </button>
        <div class="d-flex-col">
          <div class="d-flex align-items-center gap-2 pb-2">
            @switch (comment[$comment.type]) {
              @case (commentType.manualAuditIssueComment) {
                <p class="fw-bold no-margin-bottom">{{ 'added_comment' | translate }}</p>
              }
              @case (commentType.addFlag) {
                <p class="fw-bold no-margin-bottom">{{ 'added_flag' | translate }}</p>
                <ds-icon class="red-flag" [iconStyle]="IconStyles.Solid" [icon]="Icons.Flag"> </ds-icon>
              }
              @case (commentType.removeFlag) {
                <p class="fw-bold no-margin-bottom">{{ 'removed_flag' | translate }}</p>
                <ds-icon class="red-flag" [iconStyle]="IconStyles.Solid" [icon]="Icons.Flag"> </ds-icon>
              }
            }
            @if (comment[$manualAuditIssueComment.internal]) {
              <ds-chip [text]="'internal' | translate" [colorVariant]="DsChipColorVariant.Gray"></ds-chip>
            }
            @if (canEdit) {
              <button
                ds-button
                type="button"
                [variant]="DsButtonVariants.microAction"
                [microActionIcon]="Icons.Pencil"
                data-test-id="comment-edit-button"
                #editButton
                (click)="startEdit()"
              >
                {{ 'form_edit' | translate }}
              </button>
            }
            @if (canDelete) {
              <button
                ds-button
                [variant]="DsButtonVariants.microAction"
                [microActionIcon]="Icons.TrashCan"
                (click)="delete()"
                data-test-id="comment-delete-button"
              >
                {{ 'action_delete' | translate }}
              </button>
            }
          </div>
          <div>
            <p class="mb-3" data-e2e-id="timestamp">
              {{ getUserAndTimestamp() }}
              @if (comment[$comment.edited]) {
                <span data-test-id="comment-edited-indicator" aria-live="polite"> ({{ 'edited' | translate }})</span>
              }
            </p>
            @if (viewComment.value === 'true') {
              <div>
                @if (comment[$comment.type] === commentType.addFlag && comment[$manualAuditIssueComment.flagReason]) {
                  <p
                    class="item-comment"
                    [class.mb-3]="!comment[$manualAuditIssueComment.message]"
                    [class.mb-2]="comment[$manualAuditIssueComment.message]"
                  >
                    {{ getFlagReasonTranslationKey(comment[$manualAuditIssueComment.flagReason]) | translate }}
                  </p>
                }
                @if (editing) {
                  <textarea
                    #editTextarea
                    class="form-element w-100"
                    data-test-id="comment-edit-textarea"
                    [formControl]="editControl"
                    [attr.aria-label]="'comment' | translate"
                    [attr.aria-invalid]="editControl.invalid && editControl.touched"
                    [attr.aria-describedby]="'comment-edit-error-' + randomString"
                  ></textarea>
                  <div data-test-id="comment-edit-error">
                    <app-form-field-error
                      name="message"
                      [field]="editControl"
                      [label]="'comment' | translate"
                      [formValidationRequest$]="editFormValidationRequest$"
                      [errorMessageId]="'comment-edit-error-' + randomString"
                    ></app-form-field-error>
                  </div>
                  <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-link fw-bold" data-test-id="comment-edit-cancel" (click)="cancelEdit()">
                      <u>{{ 'label_cancel' | translate }}</u>
                    </button>
                    <button
                      type="button"
                      class="btn fw-bold btn-outline-primary"
                      data-test-id="comment-edit-save"
                      (click)="saveEdit()"
                    >
                      {{ 'save' | translate }}
                    </button>
                  </div>
                } @else if (comment[$manualAuditIssueComment.message]) {
                  <p
                    class="mb-3 item-comment"
                    data-e2e-id="message"
                    [innerHTML]="comment[$manualAuditIssueComment.message] | linkify"
                  ></p>
                }
                @if (comment[$manualAuditIssueComment.screenshot]) {
                  <div>
                    <p class="fw-bold mb-0">{{ 'screenshot' | translate }}</p>
                    <p class="mb-3" [innerHTML]="comment[$manualAuditIssueComment.screenshot] | linkify"></p>
                  </div>
                }
                @if (comment[$manualAuditIssueComment.recommendation]) {
                  <div>
                    <p class="fw-bold mb-0">{{ 'recommendation_comment' | translate }}</p>
                    <p class="mb-3" [innerHTML]="comment[$manualAuditIssueComment.recommendation] | linkify"></p>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }

    @if (comment[$comment.type] === commentType.statusUpdate && !comment[$manualAuditIssueComment.message]) {
      <div class="col-md-12">
        <div class="d-flex mt-1 mb-1" [ngClass]="{ internal: comment[$manualAuditIssueComment.internal] }">
          <button type="button" aria-hidden="true" class="btn btn-link d-flex mt-1 mb-1 no-click" tabindex="-1">
            <svg class="align-items-start"><use xlink:href="#chevron-right"></use></svg>
          </button>
          <div class="d-flex-col">
            <div class="d-flex mb-0">
              <p class="fw-bold mb-0">{{ 'update_manual_audit_issue_status_comment' | translate }}</p>
              <p class="badge bg-primary d-flex align-item-center mb-0 mx-2">
                {{ auditFindingQAStatusDisplayLabel[comment[$manualAuditIssueComment.newManualAuditIssueStatus]] | translate }}
              </p>
              @if (comment[$manualAuditIssueComment.internal]) {
                <ds-chip [text]="'internal' | translate" [colorVariant]="DsChipColorVariant.Gray"></ds-chip>
              }
            </div>
            <p class="mb-3" data-e2e-id="timestamp">{{ getUserAndTimestamp() }}</p>
          </div>
        </div>
      </div>
    }

    @if (comment[$comment.type] === commentType.statusUpdate && comment[$manualAuditIssueComment.message]) {
      <div class="col-md-12">
        <div class="d-flex mt-1 mb-1" [ngClass]="{ internal: comment[$manualAuditIssueComment.internal] }">
          <label for="{{ 'expandStatusUpdate-' + randomString }}" class="visuallyhidden">
            {{ 'manual_audit_issue_comment_status_update' | translate }}
          </label>
          <button
            id="{{ 'expandStatusUpdate-' + randomString }}"
            type="button"
            class="btn btn-link d-flex mt-1 mb-1"
            value="true"
            [attr.aria-expanded]="viewComment.value"
            #viewComment
            (click)="viewComment.value = viewComment.value === 'true' ? 'false' : 'true'"
          >
            @switch (viewComment.value) {
              @case ('true') {
                <svg class="align-items-start"><use xlink:href="#chevron-bottom"></use></svg>
              }
              @default {
                <svg class="align-items-start"><use xlink:href="#chevron-right"></use></svg>
              }
            }
          </button>
          <div class="d-flex-col">
            <div class="d-flex mb-0">
              <p class="fw-bold mb-0">{{ 'update_manual_audit_issue_status_comment' | translate }}</p>
              <p class="badge bg-primary d-flex align-item-center mb-0 mx-2">
                {{ auditFindingQAStatusDisplayLabel[comment[$manualAuditIssueComment.newManualAuditIssueStatus]] | translate }}
              </p>
              @if (comment[$manualAuditIssueComment.internal]) {
                <ds-chip [text]="'internal' | translate" [colorVariant]="DsChipColorVariant.Gray"></ds-chip>
              }
            </div>
            <p class="mb-3" data-e2e-id="timestamp">{{ getUserAndTimestamp() }}</p>
            @if (viewComment.value === 'true') {
              <div>
                <p class="mb-3" data-e2e-id="message" [innerHTML]="comment[$manualAuditIssueComment.message] | linkify"></p>
              </div>
            }
          </div>
        </div>
      </div>
    }

    @if (comment[$comment.type] === commentType.create) {
      <div class="col-md-12">
        <div class="d-flex mt-1 mb-1">
          <label for="{{ 'expandCreatedStatus-' + randomString }}" class="visuallyhidden">
            {{ 'manual_audit_issue_comment_created_issue_status' | translate }}
          </label>
          <button
            id="{{ 'expandCreatedStatus-' + randomString }}"
            type="button"
            class="btn btn-link d-flex mt-1 mb-1"
            value="true"
            [attr.aria-expanded]="viewComment.value"
            #viewComment
            (click)="viewComment.value = viewComment.value === 'true' ? 'false' : 'true'"
          >
            @switch (viewComment.value) {
              @case ('true') {
                <svg class="align-items-start"><use xlink:href="#chevron-bottom"></use></svg>
              }
              @default {
                <svg class="align-items-start"><use xlink:href="#chevron-right"></use></svg>
              }
            }
          </button>
          <div class="d-flex-col">
            <div>
              <p class="fw-bold mb-0">{{ 'manual_audit_issue_comment_created_issue_status' | translate }}</p>
              <p class="mb-3" data-e2e-id="timestamp">{{ getUserAndTimestamp() }}</p>
            </div>
            @if (viewComment.value === 'true') {
              <div>
                <p class="mb-3" data-e2e-id="message">
                  {{ 'manual_audit_issue_comment_create_issue' | translate: [comment[$manualAuditIssueComment.message]] }}
                </p>
              </div>
            }
          </div>
        </div>
      </div>
    }

    @if (comment[$comment.type] === commentType.taskCreate) {
      <div class="col-md-12">
        <div class="d-flex mt-1 mb-1">
          <label for="{{ 'expandCreatedTask-' + randomString }}" class="visuallyhidden">
            {{ 'task_created' | translate }}
          </label>
          <button
            id="{{ 'expandCreatedTask-' + randomString }}"
            type="button"
            class="btn btn-link d-flex mt-1 mb-1"
            value="true"
            [attr.aria-expanded]="viewComment.value"
            #viewComment
            (click)="viewComment.value = viewComment.value === 'true' ? 'false' : 'true'"
          >
            @switch (viewComment.value) {
              @case ('true') {
                <svg class="align-items-start"><use xlink:href="#chevron-bottom"></use></svg>
              }
              @default {
                <svg class="align-items-start"><use xlink:href="#chevron-right"></use></svg>
              }
            }
          </button>
          <div class="d-flex-col">
            <div>
              <p class="fw-bold mb-0">{{ 'task_created' | translate }}</p>
              <p class="mb-3" data-e2e-id="timestamp">{{ getUserAndTimestamp() }}</p>
            </div>
            @if (viewComment.value === 'true') {
              <div>
                @if (isRelatedTaskExist()) {
                  <p class="mb-3" data-e2e-id="message">
                    <span
                      [innerHTML]="'task_created_comment' | translateHtml: [taskLink, comment[$taskCreateComment.taskProjectId]]"
                    ></span>
                  </p>
                }
                @if (!isRelatedTaskExist()) {
                  <p class="mb-3" data-e2e-id="message">
                    <span>{{ 'task_created_comment_without_link' | translate }}</span>
                  </p>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }

    @if (comment[$comment.type] === commentType.taskDelete) {
      <div class="col-12">
        <div class="d-flex mt-1 mb-1">
          <label for="{{ 'expandDeletedTask-' + randomString }}" class="visuallyhidden">
            {{ 'task_deleted' | translate }}
          </label>
          <button
            id="{{ 'expandDeletedTask-' + randomString }}"
            type="button"
            class="btn btn-link d-flex mt-1 mb-1"
            value="true"
            [attr.aria-expanded]="viewComment.value"
            #viewComment
            (click)="viewComment.value = viewComment.value === 'true' ? 'false' : 'true'"
          >
            @switch (viewComment.value) {
              @case ('true') {
                <svg class="align-items-start"><use xlink:href="#chevron-bottom"></use></svg>
              }
              @default {
                <svg class="align-items-start"><use xlink:href="#chevron-right"></use></svg>
              }
            }
          </button>
          <div class="d-flex-col">
            <div>
              <p class="fw-bold mb-0">{{ 'task_deleted' | translate }}</p>
              <p class="mb-3" data-e2e-id="timestamp">{{ getUserAndTimestamp() }}</p>
            </div>
            @if (viewComment.value === 'true') {
              <div>
                <p class="mb-3" data-e2e-id="message">
                  <span [innerHTML]="'task_deleted_comment' | translateHtml: [comment[$taskDeleteComment.taskProjectId]]"></span>
                </p>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
